import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../api/Api';

export interface SettingStore {
  loaded: boolean
  welcomeScreen: boolean
  portalId: string | null
  formGuid: string | null
  generalFilesSize: string
  academicReportFileSize: string
  syllabusFileSize: string
  programFileSize: string
  checkPendingRequests: boolean
  deletedFilesEnabled: boolean
  rekognitionUrl: string
  rekognitionStatus: number
  language: 'es' | 'en',
  callHubspot: boolean,
  minContentThreshold: number,
  equivalencyRuleCheckEnabled: boolean,
  draftEnable: boolean
}

export const fetchSettings = createAsyncThunk(
  'fetchSettings', async () => {
    return await API.getSettings();
  }
);

const initialState: SettingStore = {
  loaded: false,
  welcomeScreen: true,
  portalId: null,
  formGuid: null,
  generalFilesSize: '',
  academicReportFileSize: '',
  syllabusFileSize: '',
  programFileSize: '',
  checkPendingRequests: false,
  deletedFilesEnabled: false,
  rekognitionUrl: '',
  rekognitionStatus: 2,
  language: 'es',
  callHubspot: false,
  minContentThreshold: 0,
  equivalencyRuleCheckEnabled: false,
  draftEnable: false
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSettings.fulfilled, (state, action) => {
      state.welcomeScreen = action.payload.settings.welcomeScreen;
      state.loaded = true;
      state.portalId = action.payload.settings.portalId;
      state.formGuid = action.payload.settings.formGuid;
      state.generalFilesSize = action.payload.settings.generalFilesSize;
      state.academicReportFileSize = action.payload.settings.academicReportFileSize;
      state.syllabusFileSize = action.payload.settings.syllabusFileSize;
      state.programFileSize = action.payload.settings.programFileSize;
      state.checkPendingRequests = action.payload?.settings?.checkPendingRequests ?? false;
      state.deletedFilesEnabled = action.payload?.settings?.deletedFilesEnabled ?? false;
      state.rekognitionUrl = action.payload?.settings?.rekognitionUrl ?? false;
      state.rekognitionStatus = action.payload?.settings?.rekognitionStatus ?? 2;
      state.callHubspot = action.payload.settings.callHubspot;
      state.minContentThreshold = action.payload.settings.minContentThreshold;
      state.equivalencyRuleCheckEnabled = action.payload?.settings?.equivalencyRuleCheckEnabled ?? false;
      state.draftEnable = action.payload?.settings?.draftEnable;
    });
  }
});

export default settingsSlice.reducer;
